import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DropdownModule } from '@epicuro-next/ataraxia/dropdown';
import { IconsModule } from '@epicuro-next/ataraxia/icons';

import { LanguageSelectorComponent } from './language-selector.component';

/**
 * Language selector module
 */
@NgModule({
  declarations: [LanguageSelectorComponent],
  imports: [CommonModule, DropdownModule, IconsModule],
  exports: [LanguageSelectorComponent],
})
export class LanguageSelectorModule {}
